module.exports = __webpack_public_path__ + "static/media/C2839F4C-AAD8-4A98-9ACD-2DF88F810CF0.6556406c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/make_over/C2839F4C-AAD8-4A98-9ACD-2DF88F810CF0.jpg
// module id = 312
// module chunks = 0